import colors, { palette } from '../colors';
export default {
  main: {
    color: palette.primary
  },
  wrapper: {
    position: 'relative',
    height: '14px,',
    padding: ' 5px 0',
    width: '100%',
    borderRadius: '6px',
    '-ms-touch-action': 'none',
    touchAction: 'none',
    boxSizing: 'border-box',
    '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)'
  },
  rail: {
    position: 'absolute',
    width: '100%',
    backgroundColor: colors.cloudyBlue,
    height: '2px',
    borderRadius: '6px'
  },
  track: {
    position: 'absolute',
    left: '0',
    height: '2px',
    borderRadius: '6px',
    backgroundColor: palette.primary
  },
  handle: {
    position: 'absolute',
    width: '24px',
    height: '24px',
    border: '4px solid #FFF',
    marginTop: '-10px',
    cursor: 'grab',
    borderRadius: '50%',
    backgroundColor: palette.primary,
    '-ms-touch-action': 'pan-x',
    touchAction: 'pan-x',
    '&:focus': {
      border: '4px solid #fff',
      boxShadow: 'none',
      outline: 0
    },
    '&:active': {
      transform: 'translateX(-50%) scale(1.4) !important',
      border: '4px solid #fff',
      boxShadow: 'none',
      cursor: 'grabbing'
    }
  }
};